import { NgModule } from '@angular/core';
import { SharedModule } from 'app/components/shared.module';
import { FourSectionsLayout, FourSectionsLayoutComponent } from 'app/views/presentations/layouts/layouts/fourSectionsLayout/fourSectionsLayout.component';
import { SectionModule } from 'app/views/presentations/layouts/layouts/section.module';
import { LayoutWrapperModule } from 'app/views/presentations/layouts/layoutWrapper.module';
import { WidgetModule } from 'app/views/presentations/widgets/widget.module';

@NgModule({
    imports: [
        SharedModule,
        SectionModule,
        LayoutWrapperModule.wrapLayout(FourSectionsLayout)
    ],
    declarations: [
        FourSectionsLayoutComponent
    ],
    entryComponents: [
        FourSectionsLayoutComponent
    ]
})
export class FourSectionsLayoutModule { }


// WEBPACK FOOTER //
// ./src/app/views/presentations/layouts/layouts/fourSectionsLayout/fourSectionsLayout.module.ts